<template>
  <div class="chart-case">
    <div
      class="chart-wrap"
      v-loading="loading"
      element-loading-text="数据量巨大，正在计算中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 1)">
      <div style="flex: 1; position: relative; width: 70%">
        <div class="download-wrap" style="right: calc(var(--ROOTFONTFIZE) * (55 / 144))">
          <Download
            :dButtonsDownloads="dButtonsDownloads"
            :excel_info="excel_info"
            echartRefName="echart_instance" />
        </div>
        <div
          class="iconfont icon-fangda"
          style="top: 3px; right: 11.5%"
          @click="show_chart_dialog = true"></div>
        <div ref="echart_instance" style="width: 100%; height: 100%"></div>
      </div>
      <div style="width: 30%; max-width: 400px">
        <div class="download-wrap">
          <Download
            :dButtonsDownloads="dButtonsDownloads_2"
            :excel_info="excel_info_2"
            echartRefName="echart_instance" />
        </div>
        <el-table
          class="table1"
          :header-cell-style="tableStyle"
          :data="table_data"
          height="360"
          style="width: 100%"
          size="mini">
          <el-table-column
            min-width="130"
            v-for="col in table_column"
            :label="col.label"
            :prop="col.prop"
            :align="col.align"
            :key="col.prop">
            <template slot-scope="scope">
              <div v-if="col.label === '主要参数提示'">
                {{ scope.row[col.prop] }}
              </div>
              <div v-else>
                <div v-if="scope.row.index === 'beta' || scope.row.index === 'sharp_ratio'">
                  {{ scope.row[col.prop] | fix2_ }}
                </div>
                <div v-else>
                  {{ scope.row[col.prop] | pct }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <ChartDialog :show.sync="show_chart_dialog" :echart_options="chart_dialog_options" />
  </div>
</template>

<script>
import { fnReturnTableStyle } from '@/utils/util';
import ChartDialog from '@/components/Basic/ChartDialog.vue';
import Download from '@/components/Basic/Download.vue';
import { numberFix2, number2Pct } from '@/utils';

export default {
  props: {
    queryString: String,
  },
  components: { Download, ChartDialog },
  data() {
    return {
      ROOTFONTFIZE: '',
      excel_info: Object.freeze({
        overviewName: '收益构成-图表',
        excel_data: [],
        json_fields: {},
      }),
      excel_info_2: Object.freeze({
        overviewName: '收益构成-表格',
        excel_data: [],
        json_fields: {},
      }),
      dButtonsDownloads: Object.freeze([
        {
          id: '241020',
          name: '下载图片',
        },
        {
          id: '241020',
          name: '下载表格',
        },
      ]),
      dButtonsDownloads_2: Object.freeze([
        /*   {
          id: '241020',
          name: '下载图片',
        }, */
        {
          id: '241020',
          name: '下载表格',
        },
      ]),
      table_data: [],
      table_column: Object.freeze([
        {
          label: '主要参数提示',
          prop: 'index',
          align: 'left',
        },
        {
          label: '自选指数',
          prop: 'portfolio',
          align: 'right',
        },
        {
          label: '基准',
          prop: 'benchmark',
          align: 'right',
        },
      ]),
      show_chart_dialog: false,
      chart_data: [],
      chart_dialog_options: {},
      loading: true,
      echart_instance: null,
    };
  },
  computed: {
    tableStyle() {
      const val = this.$store.state.theme === 'dark';
      return () => fnReturnTableStyle(val);
    },
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
  },
  watch: {
    currentTheme(newVal, oldVal) {
      setTimeout(() => {
        this.resize();
        this.initChart();
      }, 0);
    },
    queryString: {
      handler: function () {
        this.loadData();
      },
      immediate: true,
    },
  },
  filters: {
    pct(n) {
      if (n === '') return '';
      return number2Pct(n);
    },
    fix2(n) {
      if (n === '') return '';
      return numberFix2(n, 2);
    },
    fix2_(n) {
      if (n === '') return '';
      return numberFix2(n, 2, 'ceil');
    },
  },
  methods: {
    setDownloadData(data = {}) {
      this.excel_info = Object.freeze({
        ...this.excel_info,
        excel_data: data.data || [],
        json_fields: {
          日期: 'tr_date',
          价格回报: '价格回报',
          分红收益: '分红收益',
          // 总收益: '总收益',
        },
      });
      this.excel_info_2 = Object.freeze({
        ...this.excel_info_2,
        excel_data: data.table || [],
        json_fields: {
          主要参数提示: 'index',
          自选指数: 'portfolio',
          基准: 'benchmark',
        },
      });
    },
    async loadData() {
      this.loading = true;
      const { data } = await this.$https.get(`/api/v3_1/get_portfolio_return?${this.queryString}`);
      if (data.code !== 200) return this.$message.error(data.msg);
      // console.clear();
      this.chart_data = Object.freeze(data.data);
      this.table_data = Object.freeze(data.table);
      this.loading = false;
      this.$nextTick(() => {
        this.initChart();
      });
      this.setDownloadData(data);
    },
    initChart() {
      this.echart_instance = this.$echarts.init(this.$refs.echart_instance);
      this.echart_instance.clear();
      let x = this.chart_data.map((node) => {
        return node.tr_date;
      });
      let y1 = this.chart_data.map((node) => {
        return node['价格回报'] - 1;
      });
      let y2 = this.chart_data.map((node) => {
        return node['分红收益'];
      });
      let lightOpacity = this.$store.state.lightOpacity;
      let theme = this.$store.state.theme;
      console.log('T1', theme);
      let OPTIONDATA =
        this.$store.state.theme == 'dark'
          ? this.$store.state.OPTIONDATA
          : this.$store.state.OPTIONDATA_light;
      let option = {
        toolbox: {
          // 工具箱按钮
          right: '5%',
          top: -5,
          itemSize: 18,
          iconStyle: {
            borderColor: OPTIONDATA.toolbox.iconStyle.borderColor,
          },
          feature: {
            dataZoom: {}, // 区域缩放
          },
        },
        grid: {
          top: this.ROOTFONTFIZE * (50 / 144),
          left: this.ROOTFONTFIZE * (30 / 144),
          right: this.ROOTFONTFIZE * (50 / 144),
          bottom: this.ROOTFONTFIZE * (80 / 144),
          containLabel: true,
        },
        dataZoom: [
          //用于区域缩放
          {
            type: 'inside',
            xAxisIndex: [0, 1],
            start: 0,
            end: 100,
          },
          {
            show: true,
            xAxisIndex: [0, 1],
            type: 'slider',
            bottom: 10,
            start: 0,
            end: 100,
            height: 20,
            textStyle: { color: OPTIONDATA.legend.textStyle.color, fontSize: 14 },
          },
        ],
        legend: {
          show: true,
          orient: 'horizontal',
          left: 'center',
          align: 'left',
          bottom: 45,
          icon: 'roundRect',
          itemGap: 15,
          itemWidth: 40,
          itemHeight: 8,
          padding: [0, 0, 0, 0],
          lineStyle: {
            color: 'inherit',
          },
          textStyle: {
            color: OPTIONDATA.legend.textStyle.color,
            fontSize: 14,
          },
          data: '',
        },
        tooltip: {
          trigger: 'axis',
          triggerOn: 'mousemove|click',
          formatter: function (args) {
            let str = '';
            str += `${args[0].axisValueLabel}`;
            args.forEach((node) => {
              let val = (Number(node.value) * 100).toFixed(2);
              str += '<br>';
              str += `${node.marker}${node.seriesName}：${val}%`;

              return str;
            });
            return str;
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          splitNumber: 4,
          axisLine: {
            show: true,
          },
          axisTick: {
            show: true,
          },
          axisLabel: {
            fontSize: 14,
            show: true,
            showMaxLabel: true,
            margin: 20,
            color: OPTIONDATA.xAxis.axisLabel.color,
          },
          data: x,
        },
        yAxis: {
          // name: '',
          nameTextStyle: {
            color: OPTIONDATA.yAxis.nameTextStyle.color,
            fontSize: OPTIONDATA.yAxis.nameTextStyle.fontSize,
          },
          nameGap: OPTIONDATA.yAxis.nameGap,
          scale: true,
          type: 'value',
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: 14,
            show: true,
            color: OPTIONDATA.yAxis.axisLabel.color,
            formatter: function (args) {
              return (Number(args) * 100).toFixed(2) + '%';
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: OPTIONDATA.splitLine.lineStyle.color,
            },
          },
        },
        series: [
          {
            name: '价格回报',
            stack: '1',
            data: y1,
            type: 'line',
            smooth: false,
            lineStyle: {
              width: 0,
            },
            symbol: 'none',
            areaStyle: {
              opacity: 1,
            },
            label: {
              show: false,
              position: 'top',
            },
            markPoint: '',
            color: '#59e8ee',
          },
          {
            name: '分红收益',
            stack: '1',
            data: y2,
            type: 'line',
            smooth: false,
            lineStyle: {
              width: 0,
            },
            symbol: 'none',
            areaStyle: {
              opacity: 1,
            },
            label: {
              show: false,
              position: 'top',
            },
            markPoint: '',
            color: '#00b1ef',
          },
        ],
      };
      this.chart_dialog_options = Object.freeze(option);
      this.echart_instance.setOption(option);
      this.echart_instance.resize();
    },
    fnGetWidth() {
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1400 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;
      this.ROOTFONTFIZE = ROOTFONTFIZE / 10;
      return;
    },
    resize() {
      this.fnGetWidth();
      this.echart_instance && this.echart_instance.resize();
    },
  },
  mounted() {
    this.resize();
    window.addEventListener('resize', this.resize);
    this.$root.$on('chartResize', () => {
      setTimeout(() => {
        this.resize();
      }, 0);
    });
  },
  beforeDestroy() {
    this.$root.$off('chartResize');
    window.removeEventListener('resize', this.resize);
    this.echart_instance && this.echart_instance.dispose();
    this.echart_instance = null;
  },
};
</script>

<style scoped lang="less">
.chart-wrap {
  position: relative;
  display: flex;
  /deep/.el-table__body .el-table__row .el-table__cell {
    padding: 0 !important;
    height: calc(var(--ROOTFONTFIZE) * (35 / 144)) !important;
  }
  .download-wrap {
    position: absolute;
    right: 0;
    top: -35px;
  }
}

/* el-table start */

::v-deep .table1 table {
  border: none;
}

::v-deep .el-table__body .el-table__row .el-table__cell {
  background-color: var(--table_bgc);
  color: var(--table_color);
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  height: calc(var(--ROOTFONTFIZE) * (60 / 144));
  border-bottom: calc(var(--ROOTFONTFIZE) * (1 / 144)) solid var(--table_brc);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: var(--table_bgc_hover);
  /* background-color: var(--table_color_hover); */
  color: var(--table_color_hover);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell:hover {
  cursor: pointer;
}

::v-deep .el-table::before {
  background-color: var(--table_bgc);
}

::v-deep .el-table {
  border-bottom: none !important;
  background-color: var(--table_bgc);
}

/* el-table end */
</style>
